var map = {
	"./search-results-page.de-CH.json": 1288,
	"./search-results-page.de-DE.json": 1289,
	"./search-results-page.en-CA.json": 1290,
	"./search-results-page.en-GB.json": 1291,
	"./search-results-page.en-IN.json": 1292,
	"./search-results-page.en-ME.json": 1293,
	"./search-results-page.en-US.json": 1294,
	"./search-results-page.es-EM.json": 1295,
	"./search-results-page.es-ES.json": 1296,
	"./search-results-page.fr-BE.json": 1297,
	"./search-results-page.fr-CA.json": 1298,
	"./search-results-page.fr-CH.json": 1299,
	"./search-results-page.nl-BE.json": 1300,
	"./search-results-page.nl-NL.json": 1301,
	"./search-results-page.pl-PL.json": 1302,
	"./search-results-page.pt-BR.json": 1303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1287;